import Header from "./Header";
import Main from "./Main";

export default Main;
export {Header, Main};
export type {};
